import React from 'react';

import styles from './StepHeading.module.scss';

interface StepHeadingProps {
  title: string;
  desc?: string;
}

export const StepHeading: React.FC<StepHeadingProps> = ({ title, desc }) => {
  return (
    <div className={styles.details}>
      <h1 className={styles.title}>{title}</h1>
      {desc && <p className={styles.description}>{desc}</p>}
    </div>
  );
};
